import * as React from 'react';
import { cn } from '../utils/cn';

export function Spinner({ className, ...props }: React.HTMLAttributes<HTMLSpanElement>) {
  return (
    <span
      role="status"
      aria-label="Betöltés"
      className={cn(
        'inline-block size-5 animate-spin rounded-full border-2 border-brand-200 border-t-brand-600',
        className,
      )}
      {...props}
    />
  );
}
